var _style, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRolloverScroll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ArrowRolloverScroll",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70.9 70.9",
    style: {
      enableBackground: "new 0 0 70.9 70.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.996;}\n\t.st1{fill:#FB8861;}\n\t.st2{fill:#FDBB63;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:#1D1D1B;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_48_1_",
    transform: "translate(-11171.644 -6527.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42_1_",
    className: "st2",
    d: "M11186.3,6569.4l14.9,14.9l2,2.8l0.9-0.3l-0.3-3.4v-53.9h6.6v53.9l-0.3,3.4l0.9,0.3l2-2.8 l14.9-14.9l4.6,4.5l-22.7,22.7h-5.2l-22.7-22.7L11186.3,6569.4z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRolloverScroll);
export default __webpack_public_path__ + "static/media/Arrow_Rollover_Scroll.c2fb97cf787879d91b3203918829db61.svg";
export { ForwardRef as ReactComponent };